import {Loading} from '../../components';
import {useName} from '../../hooks';
import {PageContent} from './PageContent';

export function ActivateWhileAuthenticated() {
    const {
        error,
        loading,
        name,
    } = useName();

    if (loading) {
        return (
            <div className={'center-within'}>
                <Loading />
            </div>
        );
    }

    return (
        <PageContent
            buttonDataTestId={'continue-button'}
            buttonKey={'kit.activate.loggedIn.button.text'}
            buttonTitleKey={'kit.activate.loggedIn.button.title'}
            name={error ? null : name}
            titleDataTestId={'activate-while-authenticated'}
            titleKey={'kit.activate.loggedIn.title'}
        />
    );
}
